import { render, staticRenderFns } from "./aboutUs.vue?vue&type=template&id=344e96c5&scoped=true&"
import script from "./aboutUs.vue?vue&type=script&lang=js&"
export * from "./aboutUs.vue?vue&type=script&lang=js&"
import style0 from "./aboutUs.vue?vue&type=style&index=0&id=344e96c5&lang=css&scoped=true&"
import style1 from "./aboutUs.vue?vue&type=style&index=1&id=344e96c5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "344e96c5",
  null
  
)

export default component.exports